import { render, staticRenderFns } from "./LineUpAcheteursMatching.vue?vue&type=template&id=8b2d28fe&scoped=true&"
import script from "./LineUpAcheteursMatching.vue?vue&type=script&lang=ts&"
export * from "./LineUpAcheteursMatching.vue?vue&type=script&lang=ts&"
import style0 from "./LineUpAcheteursMatching.vue?vue&type=style&index=0&id=8b2d28fe&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b2d28fe",
  null
  
)

export default component.exports